<form [formGroup]="formGroup">
    <mat-radio-group formControlName="userContactMethodRadio">
        <label *ngFor="let device of devices" class="contact-method" [ngClass]="{'contact-method-checked': formGroup.controls.userContactMethodRadio.value == device.mfaDeviceType}">
            <mat-radio-button [value]="device.mfaDeviceType">
                <span class="contact-method-title" *ngIf="device.mfaDeviceType == MFADeviceTypeEnum.SMS">Text Message</span>
                <span class="contact-method-title" *ngIf="device.mfaDeviceType == MFADeviceTypeEnum.Email">Email</span>
            </mat-radio-button>
            <div class="contact-method-details-ctr">
                <div class="contact-method-details">
                    <i [ngClass]="{'fas fa-phone': device.mfaDeviceType == MFADeviceTypeEnum.SMS, 'far fa-envelope': device.mfaDeviceType == MFADeviceTypeEnum.Email}" class="login-input-icon login-user-contact-methods-icon"></i>
                    <span [ngClass]="{'contact-method-display-text-checked': formGroup.controls.userContactMethodRadio.value == device.mfaDeviceType}">
                        {{ device.displayText }}
                    </span>
                </div>
            </div>
        </label>
    </mat-radio-group>
</form>